import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DFA from '@nykaa/cart-shared/wrapper/DFA';
import { deviceTypes, ORIGIN_SOURCE } from '@nykaa/cart-shared/constants';
import { setToastMessage } from '@nykaa/cart-shared/store/action';
import {
  addItemToCart,
  getFreeShippingProducts,
} from '@nykaa/cart-shared/store/service';
import { EDD_EXPERIEMENT_HEADER } from '@nykaa/cart-shared/store/constants';
import { logger } from '@nykaa/logger';
import { State } from 'store/types';

interface FreeShippingProps {
  fetchCartInfo: () => void;
  isConvenienceFeeEnabled?: boolean;
}

const FreeShippingWidget = ({
  fetchCartInfo,
  isConvenienceFeeEnabled,
}: FreeShippingProps) => {
  const dispatch = useDispatch();
  const { items, shippingDataDTO, cartPriceDTO, pincode } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );
  const groupId = useSelector((state: State) => state.auth.user.groupId);
  const [productList, setProductList] = useState({} as any);
  const eddWidget =
    useSelector((state: State) => state.remoteConfig.switches?.cartEddWidget) ||
    false;

  const minimumAmount =
    (shippingDataDTO?.shippingChargeLimit || 0) - (cartPriceDTO?.subtotal || 0);

  const loadFreeShippingProducts = async () => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      ids: items.map((x) => x.productId).join(','),
      pincode: pincode,
      originSource: ORIGIN_SOURCE.CART,
      headers: { [EDD_EXPERIEMENT_HEADER]: eddWidget },
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
      algo: 'default',
      customer_group_id: groupId,
    };

    try {
      const data = await getFreeShippingProducts(params);
      if (data) {
        setProductList(data);
      }
    } catch (err) {
      logger.error(err as Error, 'Error while fetching dfa products');
    }
  };
  useEffect(() => {
    if (items?.length) {
      loadFreeShippingProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  const handleAddToBag = async (productId: string) => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
      pro: true,
      items: [
        {
          productId: productId,
          quantity: 1,
        },
      ],
      pincode,
      originSource: ORIGIN_SOURCE.CART,
      headers: { [EDD_EXPERIEMENT_HEADER]: eddWidget },
    };
    try {
      const data = await addItemToCart(params, isConvenienceFeeEnabled);
      if (data) {
        fetchCartInfo();
      }
    } catch (err) {
      setToastMessage(err?.message || 'Something Went Wrong!')(dispatch);
      logger.error(err as Error, 'Error while adding item to bag');
    }
  };

  const config: any = {
    title: productList?.widgetTitle.replace(
      '<value>',
      `₹${(shippingDataDTO?.appliedShippingCharge || 0).toString()}`
    ),
    subTitle: productList.widgetDesc.replace(
      '<value>',
      `₹${minimumAmount.toString()}`
    ),
    products: productList?.products || [],
    shippingDataDTO,
    cartPriceDTO,
    handleAddToBag,
  };

  return <DFA {...config} />;
};

export default FreeShippingWidget;
